import {handleStickySwitchElement} from "./sticky-switch-handler.js";
document.querySelectorAll(".ce--container_dsmw-stickySwitch").forEach((ce) => {
  handleStickySwitchElement(ce);
});
